import { createFileRoute } from '@tanstack/react-router';
import AuthenticateRoute from 'src/components/organisms/app-layouts/authenticate-route/authenticate-route';
import { PropertyEditorPage } from 'src/modules/catalog/components/pages/property-editor.page';
import { propertyEditorPathSchema } from 'src/modules/catalog/schemas/property-editor.schema';
import { propertiesSearchSchema } from 'src/modules/catalog/schemas/properties-search.schema';

export const Route = createFileRoute('/catalog/properties/$propertyId/edit')({
  component: CatalogPropertiesEditComponent,
  validateSearch: (search) => propertiesSearchSchema.parse(search),
  params: {
    parse: (params) => propertyEditorPathSchema.parse(params),
  },
});

function CatalogPropertiesEditComponent() {
  const { propertyId } = Route.useParams();
  const search = Route.useSearch();

  return (
    <AuthenticateRoute>
      <PropertyEditorPage propertyId={propertyId} backSearch={search} />
    </AuthenticateRoute>
  );
}

export default Route;
